import { render, staticRenderFns } from "./quiz_passed.vue?vue&type=template&id=3aa23eb2&"
import script from "./quiz_passed.vue?vue&type=script&lang=js&"
export * from "./quiz_passed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports